
const functionalityStyle = {
    data() {
        return {
            style_wrapperStyle: {},
            style_wrapperActiveStyle: {},
            style_panelStyle: {},
            style_transitionStyle: {},
        };
    },
    mounted() {
        const panelWidth = this.panelWidth;
        const menuOpenSpeed = this.menuOpenSpeed;
        const menuSwitchSpeed = this.menuSwitchSpeed;

        const menuOpenTransitionSecond = `.${menuOpenSpeed / 10}s`;
        const menuSwitchTransitionSecond = `.${menuSwitchSpeed / 10}s`;

        const wrapperStyle = {
            position: `fixed`,
            height: `calc(100vh - 51px)`,
            overflow: `hidden`,
            transition: `left ${menuOpenTransitionSecond}`,
        };

        const wrapperActiveStyle = {
            left: 0,
        };

        const panelStyle = {
            position: `absolute`,
            top: 0,
            zIndex: 99999,
            height: `calc(100vh - 51px)`,
            width: `${panelWidth}`,
            backgroundColor: `#fff`,
        };

        const transitionStyle = {
            transition: `left ${menuSwitchTransitionSecond}`,
        };

        this.style_wrapperStyle = wrapperStyle;
        this.style_wrapperActiveStyle = wrapperActiveStyle;
        this.style_panelStyle = panelStyle;
        this.style_transitionStyle = transitionStyle;
    },
};

export default functionalityStyle;
